import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getHonors } from '../actions/portfolioActions'
import HonorsSection from './sections/HonorsSection'

function HonorsPage() {
  const dispatch = useDispatch()
  useEffect(() => { dispatch(getHonors()) }, [dispatch])
  return <HonorsSection />
}

export default HonorsPage
